import { useMemo } from "react";

/**
 * Read CSS custom properties for recharts coloring.
 * Returns stable hex strings that update when the theme changes.
 */
export default function useThemeColors() {
  return useMemo(() => {
    const style = getComputedStyle(document.documentElement);
    const get = (prop) => style.getPropertyValue(prop).trim() || undefined;
    return {
      text: get("--theme-text") || "#111827",
      secondary: get("--theme-secondary-bg") || "#F9FAFB",
      shadow: get("--theme-shadow") || "#E5E7EB",
      primary: get("--theme-primary") || "#06B6D4",
      accent: get("--theme-secondary") || "#10B981",
      mainBg: get("--theme-main-bg") || "#FFFFFF",
    };
  }, []);
}
